
<adc-dialog id="session-timeout-dialog"
            class="session-timeout-dialog"
            [open]="showDialog$ | async"
            (adc-request-close)="confirmClose($event)">

  @if (!(expiredDialog$ | async)) {
    <h3 slot="label">{{ 'sessionDialog.sessionWarningHeader' | translate }}</h3>
    <p>{{ 'sessionDialog.sessionWarningBody1' | translate }}</p>
    <p>{{ 'sessionDialog.sessionWarningBody2' | translate }}</p>
  }
  @else { <!-- session expired -->
    <h3 slot="label">{{ 'sessionDialog.sessionExpiredHeader' | translate }}</h3>
    <p>{{ 'sessionDialog.sessionExpiredBody' | translate }}</p>
  }

  <div slot="footer">
    <adc-button
      role="button" kind="primary"
      (click)="closeDialog()">
      {{ (expiredDialog$ | async) ? ( 'sessionDialog.backToHomepageButton' | translate ) : ( 'sessionDialog.continueSessionButton' | translate ) }}
    </adc-button>
  </div>
</adc-dialog>
